export class ConfiguracaoNFCeRequest {
  emitirNFCeRejeitadaEmContingencia: boolean;
}
